import { useLocalSearchParams } from 'expo-router'

import { FraternityPlaceScreen } from '@/src/features/fraternity/ui/screens/FraternityPlaceScreen'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

const CommunityJoinPlaceRouterPage = () => {
  const searchParams = useLocalSearchParams()
  const { idSlug } = filterSearchParams<TIdSlugParam>(searchParams)

  if (!idSlug) return null

  return <FraternityPlaceScreen idSlug={idSlug} searchParams={searchParams} />
}

export default CommunityJoinPlaceRouterPage
